// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"94969cd7","150":"66555493","190":"b118fd39","376":"d505f4da","384":"622baeba","638":"2b437c0c","967":"7c89437b"}[chunkId] + ".chunk.js";
};